import { TRACKING_CURRENCY } from '../../const';
import { getItemBadges } from '../../helpers';
import { getProduct } from '../../helpers/getters';

import type { RootState } from 'core';

export const cartItemDelete = (action: any, prevState: RootState) => {
  const {
    meta,
    payload: { totalNum = 0 },
  } = action;
  const { productCode, quantity } = meta.payload;

  const {
    cart: { data },
  } = prevState;

  const product = getProduct(prevState, productCode);
  const badges = getItemBadges(product?.tags, prevState);
  const itemAddedIndex = data?.items?.find((item: any) => item.productCode === productCode);

  return {
    event: 'remove_from_cart',
    ecommerce: {
      currency: TRACKING_CURRENCY,
      value: totalNum,
      items: [
        {
          item_id: productCode,
          item_name: product.name,
          affiliation: product?.tags?.length ? 'promocao' : 'padrao',
          discount: product?.discount || product?.price?.discountNum || 0,
          index: product?.productIndex || itemAddedIndex?.productIndex,
          item_brand: product?.brand || '',
          item_category: product?.category || product?.department,
          item_list_name: meta.payload?.itemListName || itemAddedIndex?.itemListName || '',
          price: product?.priceNum || product?.price?.priceNum || 0,
          quantity: product?.quantity || quantity,
          cd_item_tag: badges || '',
        },
      ],
    },
  };
};
